export var DepositActionType;
(function (DepositActionType) {
    DepositActionType["QRCODE"] = "qrcode";
    DepositActionType["QRCODE_GOUBAO"] = "qrcode_goubao";
    DepositActionType["ACCESS"] = "access";
    DepositActionType["SHOW_BANK"] = "show_bank";
    DepositActionType["SHOW_CRYPTO"] = "show_crypto";
    DepositActionType["PENDING"] = "pending";
})(DepositActionType || (DepositActionType = {}));
//# sourceMappingURL=DepositActionType.js.map